var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPercentGrowth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 183,
    viewBox: "0 0 183 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.562 19.0625H3.8125V156.312H171.562V19.0625Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.438 43.4625V110.562H110.562V57.95L95.3125 67.8625V110.562H72.4375V82.35L57.1875 91.5V110.562H34.3125V106.75L3.8125 125.812H171.562V19.0625L133.438 43.4625Z",
    fill: "#BBD8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M171.562 19.0625H3.8125V156.312H171.562V19.0625Z",
    stroke: "#092F63",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8125 125.812H171.562",
    stroke: "#092F63",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6875 156.312V179.188",
    stroke: "#092F63",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5625 179.188H125.812",
    stroke: "#092F63",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3125 141.062H80.0625",
    stroke: "#092F63",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1875 80.0625H34.3125V110.562H57.1875V80.0625Z",
    stroke: "#092F63",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3125 57.1875H72.4375V110.562H95.3125V57.1875Z",
    stroke: "#092F63",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M133.438 41.9375H110.562V110.562H133.438V41.9375Z",
    stroke: "#092F63",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentGrowth);
export default __webpack_public_path__ + "static/media/percentGrowth.0b84da2480d1e941a3565c44b631766a.svg";
export { ForwardRef as ReactComponent };